/* FLGNTLT Aktions-Popup + Teaser
   --------------------------------------------------------------------------
   Konfiguration kommt aus den data-Attributen von .fa-root (Section-Settings).
   Keine Abhaengigkeiten. Laeuft auch, wenn localStorage blockiert ist.

   Zustaende pro Kampagne:
     <id>_popup   365 Tage  — Popup wurde gesehen
     <id>_teaser  Session   — Teaser wurde weggeklickt (bewusst NUR Session:
                              der Teaser ist der einzige Weg zurueck ins Popup)
   Neue Kampagnen-ID ⇒ alle sehen das Popup wieder.
*/
(function () {
  'use strict';

  var root = document.querySelector('.fa-root');
  if (!root) return;

  var popup  = root.querySelector('[data-fa-popup]');
  var teaser = root.querySelector('[data-fa-teaser]');
  var cd     = root.querySelector('[data-fa-countdown]');
  if (!popup) return;

  var CFG = {
    id:         root.getAttribute('data-campaign') || 'aktion',
    delay:      parseInt(root.getAttribute('data-delay'), 10) || 0,
    exitIntent: root.getAttribute('data-exit-intent') === 'true',
    endsAt:     root.getAttribute('data-ends-at') || ''
  };

  var K = {
    popup:  'flgntlt_aktion_' + CFG.id + '_popup',
    teaser: 'flgntlt_aktion_' + CFG.id + '_teaser'
  };

  var lastFocus = null;

  /* ---------- Speicher (privater Modus darf nichts brechen) ---------- */
  function setFlag(key, days) {
    try {
      if (days === 'session') { sessionStorage.setItem(key, '1'); return; }
      localStorage.setItem(key, String(Date.now() + days * 864e5));
    } catch (e) { /* Speicher blockiert — Popup verhaelt sich wie beim Erstbesuch */ }
  }
  function hasFlag(key, session) {
    try {
      if (session) return sessionStorage.getItem(key) === '1';
      var v = localStorage.getItem(key);
      if (!v) return false;
      if (Date.now() > Number(v)) { localStorage.removeItem(key); return false; }
      return true;
    } catch (e) { return false; }
  }

  /* ------------------------------ Countdown ------------------------------
     Nur Tage + Stunden. Wortformen kommen uebersetzt aus data-Attributen,
     damit hier keine deutschen Woerter stehen. */
  function updateCountdown() {
    if (!cd || !CFG.endsAt) return;
    var end = Date.parse(CFG.endsAt);
    if (isNaN(end)) return;
    var diff = end - Date.now();
    if (diff <= 0) { cd.hidden = true; return; }

    var d = Math.floor(diff / 864e5);
    var h = Math.floor(diff / 36e5) % 24;
    var parts = [];
    if (d > 0) parts.push(d + ' ' + root.getAttribute(d === 1 ? 'data-cd-day' : 'data-cd-days'));
    if (h > 0 || d === 0) parts.push(h + ' ' + root.getAttribute(h === 1 ? 'data-cd-hour' : 'data-cd-hours'));

    var pattern = root.getAttribute('data-cd-pattern') || '{time}';
    cd.textContent = pattern.replace('{time}', parts.join(' '));
    cd.hidden = false;
  }
  updateCountdown();
  setInterval(updateCountdown, 60000);

  /* -------------------------------- Popup -------------------------------- */
  function openPopup() {
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
    restartAnimations();
    var box = popup.querySelector('.fa-popup__box');
    if (box) box.focus({ preventScroll: true });
    if (teaser) teaser.hidden = true;
    track('view');
  }

  function closePopup() {
    popup.hidden = true;
    document.body.style.overflow = '';
    setFlag(K.popup, 365);
    if (teaser && !hasFlag(K.teaser, true)) teaser.hidden = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    track('dismiss');
  }

  /* Animationen bei jedem Oeffnen neu starten — sonst zeigt das zweite
     Oeffnen ein totes Popup. */
  function restartAnimations() {
    var nodes = popup.querySelectorAll('.fa-anim > *');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.animation = 'none';
      void nodes[i].offsetWidth;
      nodes[i].style.animation = '';
    }
  }

  /* Messung: Shopify Custom Pixel hoert auf dieses Event (siehe Plan 3b).
     Faellt still aus, wenn analytics nicht verfuegbar ist. */
  function track(action) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('flgntlt_aktion', { action: action, campaign: CFG.id });
      }
    } catch (e) { /* Messung darf die Funktion nie stoeren */ }
  }

  popup.addEventListener('click', function (e) {
    var el = e.target;
    if (el && el.hasAttribute && el.hasAttribute('data-fa-close')) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && !popup.hidden) closePopup();
  });

  var cta = popup.querySelector('[data-fa-cta]');
  if (cta) cta.addEventListener('click', function () { setFlag(K.popup, 365); track('click'); });

  /* -------------------------------- Teaser ------------------------------- */
  if (teaser) {
    var openBtn = teaser.querySelector('[data-fa-open]');
    if (openBtn) openBtn.addEventListener('click', openPopup);
    var closeBtn = teaser.querySelector('[data-fa-teaser-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      teaser.hidden = true;
      setFlag(K.teaser, 'session');
    });
  }

  /* -------------------------------- Start -------------------------------- */
  if (hasFlag(K.popup)) {
    if (teaser && !hasFlag(K.teaser, true)) teaser.hidden = false;
  } else {
    setTimeout(function () {
      if (popup.hidden && !hasFlag(K.popup)) openPopup();
    }, CFG.delay);

    if (CFG.exitIntent && window.matchMedia('(min-width: 750px)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.clientY <= 0 && popup.hidden && !hasFlag(K.popup)) {
          openPopup();
          document.removeEventListener('mouseout', onOut);
        }
      });
    }
  }
})();
